<template>
  <div data-app>
    <v-progress-linear indeterminate color="cyan"></v-progress-linear>
    <div class="row">
      <div class="col-md-12">
        <div class="v-card v-sheet">
          <div class="row">
            <div class="col-12 mb-4 bg-white p-0">
              <div class="py-3 px-4 border_b_silver col-12">
                <span class="card-label font-weight-bolder Main_Blue"
                  >Personal information</span
                >
              </div>
              <div class="pt-4 pb-0 px-4 row m-0 profile_banner">
                <div class="center_bg col-2 pr-5 p-0 bg-white">
                  <img
                    style="
                      border-radius: 8px;
                      width: 100px;
                      height: 130px;
                      object-fit: contain;
                    "
                    :src="url || ''"
                    @error="onImageLoadFailure($event)"
                  />
                    <!-- :src="url" -->
                  <v-file-input
                    style="font-size: 8px"
                    @change="Preview_image"
                    label="Profile picture"
                    v-model="image"
                    accept="image/png, image/svg, image/jpeg, .svg"
                  >
                  </v-file-input>
                </div>
                <div class="row col-10 p-0 m-0">
                  <div class="col-3 p-0">
                    <label for=""
                      >Full Name<span style="color: red">*</span></label
                    >
                    <v-text-field
                      class="border__input_ch required_ch p-0 m-0"
                      v-model="name"
                      @change="form_valdations()"
                      :class="
                        name_red == false
                          ? 'border-color-reed'
                          : 'border-color-initial'
                      "
                      :rules="rules.name"
                      required
                      placeholder="Full Name"
                    ></v-text-field>
                  </div>
                  <div class="col-3 py-0 pr-0 tooltipch">
                    <label for=""
                      >Email Address<span style="color: red">*</span></label
                    >
                    <v-text-field
                      class="
                        border__input_ch
                        required_ch
                        p-0
                        m-0
                        disabled_email_jobskere
                      "
                      v-model="email"
                      @change="form_valdations()"
                      type="email"
                      placeholder="Email Address"
                    ></v-text-field>
                    <span class="tooltiptextch1122"
                      >Please contact with <a href="/contact-us">support</a> for
                      change email</span
                    >
                  </div>
                  <div class="col-3 py-0 pr-0">
                    <label for="">CNIC<span style="color: red">*</span></label>
                    <v-text-field
                      class="border__input_ch required_ch p-0 m-0"
                      v-model="cnic"
                      @change="form_valdations()"
                      type="number"
                      :class="
                        cnic_red == false
                          ? 'border-color-reed'
                          : 'border-color-initial'
                      "
                      :rules="rules.cnic"
                      required
                      placeholder="00000-000000-00"
                    ></v-text-field>
                    <!-- <input-mask
                      @change="form_valdations()"
                      :rules="rules.cnic"
                      placeholder="00000-000000-00"
                      type="number"
                      v-model="cnic"
                      :class="
                        cnic_red == false
                          ? 'border-color-reed'
                          : 'border-color-initial'
                      "
                      class="cnic_mobile_mask border__input_ch d-block required_ch"
                      mask="99999-9999999-9"
                      maskChar=" "
                    ></input-mask> -->
                  </div>
                  <div class="col-3 py-0 pr-0">
                    <label for=""
                      >Mobile Number<span style="color: red">*</span></label
                    >
                    <v-text-field
                      class="border__input_ch required_ch p-0 m-0"
                      v-model="mobile"
                      @change="form_valdations()"
                      type="number"
                      :class="
                        mobile_red == false
                          ? 'border-color-reed'
                          : 'border-color-initial'
                      "
                      :rules="rules.mobile"
                      required
                      placeholder="Mobile Number"
                    ></v-text-field>
                  </div>
                  <div class="col-3 py-0 p-0">
                    <label for=""
                      >Gender<span style="color: red">*</span></label
                    >
                    <v-select
                      class="border__input_ch required_ch p-0 m-0"
                      v-model="genders"
                      :items="gendersOptions"
                      @change="form_valdations()"
                      placeholder="Gender"
                      attach
                      chips
                    ></v-select>
                  </div>
                  <div class="col-3 pr-0">
                    <label for=""
                      >Date of birth<span style="color: red">*</span></label
                    >
                    <v-text-field
                      class="border__input_ch required_ch p-0 m-0"
                      v-model="dob"
                      @change="form_valdations()"
                      :class="
                        dob_red == false
                          ? 'border-color-reed'
                          : 'border-color-initial'
                      "
                      type="date"
                    ></v-text-field>
                  </div>
                  <div class="col py-0 pr-0">
                    <label for=""
                      >Permanent Address<span style="color: red">*</span></label
                    >
                    <v-text-field
                      class="border__input_ch required_ch p-0 m-0"
                      v-model="address"
                      @change="form_valdations()"
                      :class="
                        address_red == false
                          ? 'border-color-reed'
                          : 'border-color-initial'
                      "
                      :rules="rules.address"
                      required
                      placeholder="Permanent Address"
                    ></v-text-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-12 pl-0">
              <div class="bg-white p-0" style="height: 100%">
                <div class="py-3 px-4 border_b_silver col-12">
                  <span class="card-label font-weight-bolder Main_Blue"
                    >Professional summary</span
                  >
                </div>
                <div class="py-2 px-4">
                  <textarea
                    name="input-7-4"
                    maxlength="600"
                    v-model="about"
                    label="About"
                    class="form-control"
                    style="border-radius: 0"
                    id="exampleFormControlTextarea1"
                    rows="10"
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="col-lg-8 col-12 p-0">
              <div class="bg-white row p-0 m-0 col-12">
                <div
                  class="
                    py-2
                    px-4
                    border_b_silver
                    d-flex
                    justify-content-between
                  "
                >
                  <span class="card-label pt-2 font-weight-bolder Main_Blue"
                    >Job details</span
                  >
                  <!-- <a
                    class="custom-submit-button btn_submit__ch111"
                    href="/custom-pages/profile"
                  >
                    <span>Edit personal information</span>
                  </a> -->
                </div>
                <div class="col-4">
                  <v-combobox
                    :class="
                      current_salary_red == false
                        ? 'border-color-reed'
                        : 'border-color-initial'
                    "
                    @change="form_valdations()"
                    v-model="current_salary"
                    :items="desiredSalaryOptions"
                    label="Current salary"
                    size="sm"
                    class="border__input_ch required_ch"
                    chips
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :key="JSON.stringify(data.item)"
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        :disabled="data.disabled"
                        @click:close="data.parent.selectItem(data.item)"
                      >
                        {{ data.item }}
                      </v-chip>
                    </template>
                  </v-combobox>
                </div>
                <div class="col-4 p-0">
                  <v-combobox
                    :class="
                      desired_salary_red == false
                        ? 'border-color-reed'
                        : 'border-color-initial'
                    "
                    @change="form_valdations()"
                    v-model="desired_salary"
                    :items="desiredSalaryOptions"
                    label="Desired Salary"
                    size="sm"
                    class="border__input_ch required_ch"
                    chips
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :key="JSON.stringify(data.item)"
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        :disabled="data.disabled"
                        @click:close="data.parent.selectItem(data.item)"
                      >
                        {{ data.item }}
                      </v-chip>
                    </template>
                  </v-combobox>
                </div>
                <div class="col-4">
                  <v-combobox
                    v-model="city"
                    :items="cityOptions"
                    label="Current Location"
                    size="sm"
                    class="border__input_ch"
                    chips
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :key="JSON.stringify(data.item)"
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        :disabled="data.disabled"
                        @click:close="data.parent.selectItem(data.item)"
                      >
                        {{ data.item }}
                      </v-chip>
                    </template>
                  </v-combobox>
                </div>
                <!-- <div class="col-4">
                  <label style="font-weight: bold">Current Location</label>
                  <b-form-select
                    v-model="city"
                    :options="cityOptions"
                    size="sm"
                    class="mt-3"
                    required
                  ></b-form-select>
                </div> -->
                <div class="col-4">
                  <v-combobox
                    v-model="interestedIn"
                    :items="interestedInOptions"
                    label="Job Shifts"
                    multiple
                    size="sm"
                    class="border__input_ch"
                    chips
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :key="JSON.stringify(data.item)"
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        :disabled="data.disabled"
                        @click:close="data.parent.selectItem(data.item)"
                      >
                        {{ data.item }}
                      </v-chip>
                    </template>
                  </v-combobox>
                </div>
                <div class="col-4 p-0">
                  <v-combobox
                    v-model="cities"
                    :items="cityOptions"
                    label="Willing to relocate"
                    multiple
                    size="sm"
                    class="border__input_ch"
                    chips
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :key="JSON.stringify(data.item)"
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        :disabled="data.disabled"
                        @click:close="data.parent.selectItem(data.item)"
                      >
                        {{ data.item }}
                      </v-chip>
                    </template>
                  </v-combobox>
                </div>
                <div class="col-4">
                  <v-checkbox
                    class="checkbox_ch"
                    style="margin-top: 8%"
                    v-model="available_for_job"
                    label="Available for Job?"
                  ></v-checkbox>
                </div>
                <div class="col-6">
                  <v-text-field
                    class="border__input_ch"
                    v-model="website"
                    type="text"
                    label="Website link"
                    required
                  ></v-text-field>
                </div>
                <div class="col-6">
                  <v-text-field
                    class="border__input_ch"
                    label="LinkedIn profile"
                    v-model="linkedin"
                    type="text"
                    required
                  ></v-text-field>
                </div>
              </div>
            </div>
            <div class="row mt-4 m-0 p-0">
              <div class="col-12 p-0">
                <div class=" row py-3 px-4 border_b_silver col-12 bg-white p-0 w-100 m-0 pr-0">
                  <span class="card-label font-weight-bolder Main_Blue"
                    >Skills & Languages</span
                  >
                </div>
                <div class="row bg-white px-4 m-0">
                  <div class="col-12">
                    <div
                      class="row"
                      v-for="(item, index) in skillsArr"
                      :key="index"
                    >
                      <div class="col-md-4 pl-0">
                        <v-combobox
                          :class="
                            job_funcation_ch_red == false
                              ? 'border-color-reed'
                              : 'border-color-initial'
                          "
                          v-model="item.job_funcation_ch"
                          :items="job_funcation_ch_Options"
                          size="sm"
                          class="border__input_ch required_ch"
                          label="Profession"
                          chips
                          @change="getProfessions(data.selected)"
                        >
                          <template>
                            <v-chip
                              :key="JSON.stringify(data.item)"
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              :disabled="data.disabled"
                              @click:close="data.parent.selectItem(data.item)"
                            >
                              {{ data.item }}
                            </v-chip>
                          </template>
                        </v-combobox>
                      </div>
                      <div class="col-md-3 p-0">
                        <v-combobox
                          :class="
                            skill_red == false
                              ? 'border-color-reed'
                              : 'border-color-initial'
                          "
                          @change="form_valdations()"
                          v-model="item.skill"
                          :items="skillsOptions"
                          size="sm"
                          class="border__input_ch required_ch"
                          label="Skills"
                          chips
                        >
                          <template>
                            <v-chip
                              :key="JSON.stringify(data.item)"
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              :disabled="data.disabled"
                              @click:close="data.parent.selectItem(data.item)"
                            >
                              {{ data.item }}
                            </v-chip>
                          </template>
                        </v-combobox>
                      </div>

                      <div class="col-md-3 pr-0">
                        <v-text-field
                          :class="
                            experience_red == false
                              ? 'border-color-reed'
                              : 'border-color-initial'
                          "
                          @change="form_valdations()"
                          class="border__input_ch required_ch"
                          label="Experience in years"
                          type="number"
                          v-model="item.experience"
                        ></v-text-field>
                      </div>

                      <div
                        class="col-md-1"
                        style="display: flex; margin-top: 2%; margin-left: 0%"
                      >
                        <v-btn
                          class="custom-add-new-record-button btn_row_ch"
                          type="button"
                          @click="addNewRowSkill()"
                          >Add</v-btn
                        >
                        <v-btn
                          v-if="index > 0"
                          class="custom-delete-new-record-button btn_row_ch"
                          type="button"
                          @click="deleteRowSkill(index)"
                          >Del</v-btn
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="row">
                      <div class="col-md-12">
                        <v-card elevation="2">
                          <div
                            class="row"
                            v-for="(item, index) in languageSkillsArr"
                            :key="index"
                          >
                            <div class="col-md-5 p-0">
                              <v-combobox
                                v-model="item.language"
                                :items="languageOptions"
                                size="sm"
                                class="border__input_ch"
                                label="Language"
                                chips
                              >
                                <template>
                                  <v-chip
                                    :key="JSON.stringify(data.item)"
                                    v-bind="data.attrs"
                                    :input-value="data.selected"
                                    :disabled="data.disabled"
                                    @click:close="
                                      data.parent.selectItem(data.item)
                                    "
                                  >
                                    {{ data.item }}
                                  </v-chip>
                                </template>
                              </v-combobox>
                            </div>

                            <div class="col-md-5 pr-0">
                              <v-combobox
                                v-model="item.level"
                                :items="levelOptions"
                                size="sm"
                                class="border__input_ch"
                                label="Proficiency"
                                chips
                              >
                                <template>
                                  <v-chip
                                    :key="JSON.stringify(data.item)"
                                    v-bind="data.attrs"
                                    :input-value="data.selected"
                                    :disabled="data.disabled"
                                    @click:close="
                                      data.parent.selectItem(data.item)
                                    "
                                  >
                                    {{ data.item }}
                                  </v-chip>
                                </template>
                              </v-combobox>
                            </div>

                            <div
                              class="col-md-1"
                              style="
                                display: flex;
                                margin-top: 1.4%;
                                margin-left: 0%;
                              "
                            >
                              <v-btn
                                class="custom-add-new-record-button btn_row_ch"
                                type="button"
                                @click="addNewRowSkill1()"
                                >Add</v-btn
                              >
                              <v-btn
                                v-if="index > 0"
                                class="custom-delete-new-record-button btn_row_ch"
                                type="button"
                                @click="deleteRowSkill1(index)"
                                >Del</v-btn
                              >
                            </div>
                          </div>
                        </v-card>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 p-0">
        <!-- create form start -->
        <v-card class="rounded-0">
          <div class="mt-5 rounded-0" style="padding: 1%">
            <v-form ref="form" @submit.prevent="submit" class="custom-form">
              <div class="row d-none">
                <div class="col-md-2">
                  <img
                    style="border-radius: 8px; width: 160px; height: 160px"
                    :src="url || ''"
                    @error="onImageLoadFailure($event)"
                  />
                    <!-- :src="url" -->
                  <v-file-input
                    style="font-size: 8px"
                    label="Profile picture"
                    @change="Preview_image"
                    v-model="image"
                    accept="image/png, image/svg, image/jpeg, .svg"
                  >
                  </v-file-input>
                </div>
                <div class="col-md-1"></div>
                <div class="col-md-9">
                  <div class="row">
                    <!-- <div class="col-md-4" style="margin-top: 1%">
                      <label>Areas of Expertise:</label>
                      <b-form-select
                        v-model="profession"
                        :options="professionOptions"
                        size="sm"
                        class="mt-3"
                        required
                      ></b-form-select>
                    </div> -->
                    <!-- <div class="col-md-4">
                      <v-combobox
                        v-model="areaOfExpertise"
                        :items="areaOfExpertiseOptions"
                        label="Job Functions"
                        multiple
                        size="sm"
                        class="mt-3"
                        chips
                        

                      >
                        <template v-slot:selection="data">
                          <v-chip
                            :key="JSON.stringify(data.item)"
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            :disabled="data.disabled"
                            @click:close="data.parent.selectItem(data.item)"
                          >
                            {{ data.item }}
                          </v-chip>
                        </template>
                      </v-combobox>
                    </div> -->
                    <div class="col-md-6">
                      <v-combobox
                        v-model="interestedIn"
                        :items="interestedInOptions"
                        label="Job Shifts"
                        multiple
                        size="sm"
                        class="mt-3"
                        chips
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            :key="JSON.stringify(data.item)"
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            :disabled="data.disabled"
                            @click:close="data.parent.selectItem(data.item)"
                          >
                            {{ data.item }}
                          </v-chip>
                        </template>
                      </v-combobox>
                    </div>
                    <div class="col-md-6">
                      <v-combobox
                        v-model="cities"
                        :items="cityOptions"
                        label="Willing to relocate"
                        multiple
                        size="sm"
                        class="mt-3"
                        chips
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            :key="JSON.stringify(data.item)"
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            :disabled="data.disabled"
                            @click:close="data.parent.selectItem(data.item)"
                          >
                            {{ data.item }}
                          </v-chip>
                        </template>
                      </v-combobox>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <!-- <v-text-field
                        type="number"
                        v-model="current_salary"
                        label="Current salary"
                      ></v-text-field> -->
                      <v-combobox
                        v-model="current_salary"
                        :items="desiredSalaryOptions"
                        label="Current salary"
                        size="sm"
                        class="mt-3"
                        chips
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            :key="JSON.stringify(data.item)"
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            :disabled="data.disabled"
                            @click:close="data.parent.selectItem(data.item)"
                          >
                            {{ data.item }}
                          </v-chip>
                        </template>
                      </v-combobox>
                    </div>

                    <div class="col-md-6">
                      <v-combobox
                        v-model="desired_salary"
                        :items="desiredSalaryOptions"
                        label="Desired Salary"
                        size="sm"
                        class="mt-3 required_ch"
                        chips
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            :key="JSON.stringify(data.item)"
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            :disabled="data.disabled"
                            @click:close="data.parent.selectItem(data.item)"
                          >
                            {{ data.item }}
                          </v-chip>
                        </template>
                      </v-combobox>
                    </div>

                    <div class="col-md-6">
                      <v-checkbox
                        class="checkbox_ch"
                        style="margin-top: 8%"
                        v-model="available_for_job"
                        label="Available for Job?"
                      ></v-checkbox>
                    </div>

                    <div class="col-md-6">
                      <v-text-field
                        v-model="cnic"
                        type="text"
                        label="CNIC"
                        required
                      ></v-text-field>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row d-none">
                <div class="col-md-12">
                  <v-card elevation="2" style="padding: 2%">
                    <div
                      class="row"
                      :style="
                        index == 0
                          ? 'margin-top: 0%; '
                          : 'margin-top: 2%; ' +
                            'padding-left: 1%; padding-right: 1%'
                      "
                      v-for="(item, index) in skillsArr"
                      :key="index"
                    >
                      <div class="col-md-4">
                        <label style="font-weight: bold"
                          >Profession<span style="color: red">*</span></label
                        >
                        <!-- <b-form-select
                          v-model="item.job_funcation_ch"
                          :options="job_funcation_ch_Options"
                          size="sm"
                          class="mt-3"
                          required
                          @change="getProfessions()"
                        ></b-form-select> -->
                        <v-combobox
                          v-model="item.job_funcation_ch"
                          :items="job_funcation_ch_Options"
                          size="sm"
                          class="mt-3 profession_slect_box_ch"
                          style="margin: 0 !important; padding: 0 !important"
                          chips
                          @change="getProfessions(data.selected)"
                        >
                          <template>
                            <v-chip
                              :key="JSON.stringify(data.item)"
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              :disabled="data.disabled"
                              @click:close="data.parent.selectItem(data.item)"
                            >
                              {{ data.item }}
                            </v-chip>
                          </template>
                        </v-combobox>
                      </div>
                      <div class="col-md-3">
                        <label style="font-weight: bold"
                          >Skills<span style="color: red">*</span></label
                        >
                        <!-- <b-form-select
                          v-model="item.skill"
                          :options="skillsOptions"
                          size="sm"
                          class="mt-3"
                          required
                        ></b-form-select> -->
                        <v-combobox
                          v-model="item.skill"
                          :items="skillsOptions"
                          size="sm"
                          class="mt-3 profession_slect_box_ch"
                          style="margin: 0 !important; padding: 0 !important"
                          chips
                        >
                          <template>
                            <v-chip
                              :key="JSON.stringify(data.item)"
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              :disabled="data.disabled"
                              @click:close="data.parent.selectItem(data.item)"
                            >
                              {{ data.item }}
                            </v-chip>
                          </template>
                        </v-combobox>
                      </div>

                      <div class="col-md-3">
                        <label style="font-weight: bold; margin: 0"
                          >Experience in years<span style="color: red"
                            >*</span
                          ></label
                        >
                        <v-text-field
                          type="number"
                          v-model="item.experience"
                        ></v-text-field>
                      </div>

                      <div
                        class="col-md-1"
                        style="display: flex; margin-top: 2%; margin-left: 2%"
                      >
                        <v-btn
                          class="custom-add-new-record-button"
                          type="button"
                          @click="addNewRowSkill()"
                          >+</v-btn
                        >
                        <v-btn
                          v-if="index > 0"
                          class="custom-delete-new-record-button"
                          type="button"
                          @click="deleteRowSkill(index)"
                          >-</v-btn
                        >
                      </div>
                    </div>
                  </v-card>
                </div>
              </div>

              <div class="row d-none" style="margin-top: 2%">
                <div class="col-md-12">
                  <v-card elevation="2" style="padding: 2%">
                    <div
                      class="row"
                      :style="
                        index == 0
                          ? 'margin-top: 0%; '
                          : 'margin-top: 2%; ' +
                            'padding-left: 1%; padding-right: 1%'
                      "
                      v-for="(item, index) in languageSkillsArr"
                      :key="index"
                    >
                      <div class="col-md-3">
                        <label style="font-weight: bold">Language</label>
                        <b-form-select
                          v-model="item.language"
                          :options="languageOptions"
                          size="sm"
                          class="mt-3"
                          required
                        ></b-form-select>
                      </div>

                      <div class="col-md-3">
                        <label style="font-weight: bold">Chose</label>
                        <b-form-select
                          v-model="item.level"
                          :options="levelOptions"
                          size="sm"
                          class="mt-3"
                          required
                        ></b-form-select>
                      </div>

                      <div
                        class="col-md-1"
                        style="display: flex; margin-top: 2%; margin-left: 2%"
                      >
                        <v-btn
                          class="custom-add-new-record-button"
                          type="button"
                          @click="addNewRowSkill1()"
                          >+</v-btn
                        >
                        <v-btn
                          v-if="index > 0"
                          class="custom-delete-new-record-button"
                          type="button"
                          @click="deleteRowSkill1(index)"
                          >-</v-btn
                        >
                      </div>
                    </div>
                  </v-card>
                </div>
              </div>

              <div class="row d-none" style="margin-top: 3%; margin-bottom: 2%">
                <div class="col-md-3">
                  <v-text-field
                    v-model="dob"
                    label="Date of birth"
                    prepend-icon="mdi-calendar"
                    type="date"
                  ></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-text-field
                    v-model="website"
                    type="text"
                    label="Website link"
                    required
                  ></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-text-field
                    v-model="linkedin"
                    type="text"
                    label="LinkedIn profile"
                    required
                  ></v-text-field>
                </div>
                <div class="col-md-3" style="margin-top: -1%">
                  <label style="font-weight: bold">Current Location</label>
                  <b-form-select
                    v-model="city"
                    :options="cityOptions"
                    size="sm"
                    class="mt-3"
                    required
                  ></b-form-select>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <v-card elevation="2">
                    <div class="col-12">
                      <span class="card-label font-weight-bolder Main_Blue"
                        >Work experience</span
                      >
                    </div>
                    <div
                      class="row"
                      :style="
                        index == 0
                          ? 'margin-top: 0%; '
                          : 'margin-top: 2%; ' + ''
                      "
                      v-for="(item, index) in workExperience"
                      :key="index"
                    >
                      <div class="col-md-3">
                        <v-text-field
                          v-model="item.companyName"
                          class="border__input_ch"
                          label="Company Name"
                        ></v-text-field>
                      </div>
                      <div class="col-md-3 pl-0">
                        <v-text-field
                          v-model="item.designation"
                          class="border__input_ch"
                          label="Designation"
                        ></v-text-field>
                      </div>
                      <div class="col-md-2 pl-0">
                        <v-text-field
                          v-model="item.startingDate"
                          class="border__input_ch"
                          label="Starting date"
                          type="date"
                        ></v-text-field>
                      </div>
                      <div
                        class="col-md-2 pl-0"
                        :style="
                          item.present == true
                            ? 'pointer-events: none;opacity: 0.6;'
                            : '' || item.startingDate == ''
                            ? 'pointer-events: none;opacity: 0.6;'
                            : ''
                        "
                      >
                        <v-text-field
                          v-model="item.endDate"
                          class="border__input_ch"
                          label="End date"
                          type="date"
                          :value="item.present == true ? null : item.endDate"
                          :style="
                            item.present == true
                              ? 'pointer-events: none;opacity: 0.6;'
                              : '' || item.startingDate == ''
                              ? 'pointer-events: none;opacity: 0.6;'
                              : ''
                          "
                        ></v-text-field>
                      </div>
                      <div class="col-md-1 pl-0 mt-3 pt-1">
                        <v-checkbox
                          class="checkbox_ch"
                          style="margin-top: 8%"
                          v-model="item.present"
                          label="Present"
                          :value="item.endDate != '' ? false : item.present"
                          :style="
                            item.endDate != ''
                              ? 'pointer-events: none;opacity: 0.6;'
                              : '' || item.startingDate == ''
                              ? 'pointer-events: none;opacity: 0.6;'
                              : ''
                          "
                        ></v-checkbox>
                      </div>
                      <div
                        class="col-md-1 pl-0"
                        style="display: flex; margin-top: 1.2%; margin-left: 0%"
                      >
                        <v-btn
                          class="custom-add-new-record-button btn_row_ch"
                          type="button"
                          @click="addNewRow()"
                          >Add</v-btn
                        >
                        <v-btn
                          v-if="index > 0"
                          class="custom-delete-new-record-button btn_row_ch"
                          type="button"
                          @click="deleteRow(index)"
                          >Del</v-btn
                        >
                      </div>
                      <div class="col-md-12">
                        <vue-editor
                          v-model="item.description"
                          outlined
                          name="input-7-4"
                          class="rounded-0"
                          label="Job description"
                          rows="2"
                          style="min-height: 84px"
                        ></vue-editor>
                      </div>
                    </div>
                  </v-card>
                </div>
              </div>

              <div class="row" style="margin-top: 2%">
                <div class="col-md-12 p-1">
                  <div class="col-12">
                    <span class="card-label font-weight-bolder Main_Blue"
                      >Education</span
                    >
                  </div>
                  <v-card elevation="2" style="padding: 1%">
                    <div
                      class="row"
                      :style="
                        index == 0
                          ? 'margin-top: 0%; '
                          : 'margin-top: 2%; ' + ''
                      "
                      v-for="(item, index) in education"
                      :key="index"
                    >
                      <div class="col-md-3">
                        <v-combobox
                          v-model="item.university"
                          :items="universities"
                          size="sm"
                          class="border__input_ch"
                          label="University"
                          chips
                        >
                          <template>
                            <v-chip
                              :key="JSON.stringify(data.item)"
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              :disabled="data.disabled"
                              @click:close="data.parent.selectItem(data.item)"
                            >
                              {{ data.item }}
                            </v-chip>
                          </template>
                        </v-combobox>
                      </div>
                      <div class="col-md-3 pl-0">
                        <v-combobox
                          v-model="item.degree"
                          :items="degrees"
                          size="sm"
                          class="border__input_ch"
                          label="Degree"
                          chips
                        >
                          <template>
                            <v-chip
                              :key="JSON.stringify(data.item)"
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              :disabled="data.disabled"
                              @click:close="data.parent.selectItem(data.item)"
                            >
                              {{ data.item }}
                            </v-chip>
                          </template>
                        </v-combobox>
                      </div>
                      <div class="col-md-2 pl-0">
                        <v-text-field
                          v-model="item.startingDate"
                          class="border__input_ch"
                          label="Starting date"
                          type="date"
                        ></v-text-field>
                      </div>
                      <div
                        class="col-md-2 pl-0"
                        :style="
                          item.present == true
                            ? 'pointer-events: none;opacity: 0.6;'
                            : '' || item.startingDate == ''
                            ? 'pointer-events: none;opacity: 0.6;'
                            : ''
                        "
                      >
                        <v-text-field
                          v-model="item.endDate"
                          class="border__input_ch"
                          label="End date"
                          type="date"
                          :value="item.present == true ? null : item.endDate"
                          :style="
                            item.present == true
                              ? 'pointer-events: none;opacity: 0.6;'
                              : '' || item.startingDate == ''
                              ? 'pointer-events: none;opacity: 0.6;'
                              : ''
                          "
                        ></v-text-field>
                      </div>
                      <div class="col-md-1 pl-0 mt-3 pt-1">
                        <v-checkbox
                          class="checkbox_ch"
                          style="margin-top: 8%"
                          v-model="item.present"
                          label="Present"
                          :value="item.endDate != '' ? false : item.present"
                          :style="
                            item.endDate != ''
                              ? 'pointer-events: none;opacity: 0.6;'
                              : '' || item.startingDate == ''
                              ? 'pointer-events: none;opacity: 0.6;'
                              : ''
                          "
                        ></v-checkbox>
                      </div>
                      <div
                        class="col-md-1 pl-0"
                        style="display: flex; margin-top: 1.2%; margin-left: 0%"
                      >
                        <v-btn
                          class="custom-add-new-record-button btn_row_ch"
                          type="button"
                          @click="addNewEducationRow()"
                          >Add</v-btn
                        >
                        <v-btn
                          v-if="index > 0"
                          class="custom-delete-new-record-button btn_row_ch"
                          type="button"
                          @click="deleteEducationRow(index)"
                          >Del</v-btn
                        >
                      </div>
                      <div class="col-md-12">
                        <vue-editor
                          v-model="item.details"
                          outlined
                          name="input-7-4"
                          label="Degree details"
                          rows="2"
                          style="min-height: 84px"
                        ></vue-editor>
                      </div>
                    </div>
                  </v-card>
                </div>
              </div>

              <div class="row" style="margin-top: 2%">
                <div class="col-md-12">
                  <v-card elevation="2">
                    <div class="col-12">
                      <span class="card-label font-weight-bolder Main_Blue"
                        >Certificate</span
                      >
                      <!-- {{ certificates }} -->
                    </div>
                    <div
                      class="row"
                      :style="
                        index == 0
                          ? 'margin-top: 0%; '
                          : 'margin-top: 2%; ' + ''
                      "
                      v-for="(item, index) in certificates"
                      :key="index"
                    >
                      <div class="col-md-3">
                        <v-text-field
                          v-model="item.certificateName"
                          class="border__input_ch"
                          label="Certificate name"
                        ></v-text-field>
                      </div>
                      <div class="col-md-3 pl-0">
                        <v-text-field
                          v-model="item.awardedBy"
                          class="border__input_ch"
                          label="Awarded by"
                        ></v-text-field>
                      </div>
                      <div class="col-md-2 pl-0">
                        <v-text-field
                          v-model="item.startingDate"
                          class="border__input_ch"
                          label="Starting date"
                          type="date"
                        ></v-text-field>
                      </div>
                      <div class="col-md-2 pl-0">
                        <v-text-field
                          v-model="item.endDate"
                          class="border__input_ch"
                          label="End date"
                          type="date"
                          :style="
                            item.startingDate == ''
                              ? 'pointer-events: none;opacity: 0.6;'
                              : ''
                          "
                        ></v-text-field>
                      </div>
                      <div
                        class="col-md-1"
                        style="display: flex; margin-top: 1.2%; margin-left: 0%"
                      >
                        <v-btn
                          class="custom-add-new-record-button btn_row_ch"
                          type="button"
                          @click="addNewCertificateRow()"
                          >Add</v-btn
                        >
                        <v-btn
                          v-if="index > 0"
                          class="custom-delete-new-record-button btn_row_ch"
                          type="button"
                          @click="deleteCertificateRow(index)"
                          >Dell</v-btn
                        >
                      </div>
                    </div>
                  </v-card>
                </div>
              </div>

              <v-card elevation="2 d-none" style="padding: 2%">
                <label style="font-weight: bold">Security Questions</label>
                <div
                  class="row"
                  :style="
                    index == 0
                      ? 'margin-top: 0%; '
                      : 'margin-top: 2%; ' +
                        'padding-left: 1%; padding-right: 1%'
                  "
                  v-for="(item, index) in security_questions"
                  :key="index"
                >
                  <div class="col-md-3">
                    <v-text-field
                      v-model="item.question"
                      label="Question"
                    ></v-text-field>
                  </div>
                  <div class="col-md-3">
                    <v-text-field
                      v-model="item.answer"
                      label="Answer"
                    ></v-text-field>
                  </div>
                  <div
                    class="col-md-1"
                    style="display: flex; margin-top: 2%"
                    v-if="security_questions.length < 2"
                  >
                    <v-btn
                      class="custom-add-new-record-button v-size--small"
                      type="button"
                      @click="addNewRow1()"
                      >+</v-btn
                    >
                    <v-btn
                      v-if="index > 0"
                      class="custom-delete-new-record-button v-size--small"
                      type="button"
                      @click="deleteRow1(index)"
                      >-</v-btn
                    >
                  </div>
                </div>
              </v-card>

              <!-- <div class="row" style="margin-top: 2%">
                <div class="col-md-12">
                  <label><b>Professional Summary</b></label>
                  <textarea
                    name="input-7-4"
                    maxlength="600"
                    v-model="about"
                    label="About"
                    class="form-control"
                    id="exampleFormControlTextarea1"
                    rows="6"
                  ></textarea>
                </div>
              </div> -->
              <!-- <div
                class="row"
                style="
                  margin-top: 2%;
                  display: flex;
                  flex-direction: column;
                  padding-left: 1.8%;
                "
              >
                <label>Terms & Conditions</label>
                <v-checkbox
                  v-model="checkbox"
                  label="I accept the Terms & Conditions and Privacy policy"
                ></v-checkbox>
              </div> -->

              <v-card-actions>
                <v-btn class="custom-submit-button btn_submit__ch" type="submit"
                  ><b-spinner small type="grow" v-if="submitting"></b-spinner>
                  <span>Update</span>
                </v-btn>
                <v-btn
                  text
                  @click="cancel"
                  class="custom-cancel-button btn_submit__ch_cls"
                  >Cancel</v-btn
                >
              </v-card-actions>
            </v-form>
          </div>
        </v-card>
        <!-- create form end -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import InputMask from "vue-input-mask";
import { API_URL, MEDIA_URL } from "@/core/api";
import Swal from "sweetalert2";
import GeneralService from "@/MainServices/GeneralService.js";
import { VueEditor } from "vue2-editor";

export default {
  data() {
    return {
      mediaUrl: MEDIA_URL,
      url: "../images/profile_ch.jpg",
      // url: "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png",
      image: null,
      form: [""],
      search: null,
      loading: true,
      success: false,
      user_id:
        localStorage.getItem("user") !== null
          ? JSON.parse(localStorage.getItem("user")).id
          : null,
      token: `Bearer ${localStorage.getItem("token")}`,
      valid: true,
      submitting: false,
      email:
        localStorage.getItem("user") !== null
          ? JSON.parse(localStorage.getItem("user")).email
          : "",
      about: "",
      checkbox: false,
      rules: {
        job_funcation_ch: [
          (val) => (val || "").length > 0 || "Company name is required",
        ],
      },
      data: [],

      security_questions: [{ question: "", answer: "" }],

      // profession: "",
      // professionOptions: [],

      job_funcation_ch: null,
      job_funcation_ch_Options: [],

      areaOfExpertise: null,
      areaOfExpertiseOptions: [],

      interestedIn: null,
      interestedInOptions: [],
      cnic: "",
      name: "",
      mobile: "",
      address: "",
      genders: null,
      gendersOptions: [],
      dob: "",
      linkedin: "",
      website: "",
      current_salary: "",
      available_for_job: 0,
      city: null,
      cityOptions: [],
      cities: [],
      desired_salary: "",
      desiredSalaryOptions: [
        "Upto 20,000",
        "20,001 - 40,000",
        "40,001 - 60,000",
        "60,001 - 80,000",
        "80,001 - 100,000",
        "100,001 - 125,000",
        "125,001 - 150,000",
        "150,001 - 175,000",
        "175,001 - 225,000",
        "225,001 - 275,000",
        "275,001 - 300,000",
        "300,000 - 350,000",
        "350,000 +",
      ],
      skillsArr: [
        {
          job_funcation_ch: "",
          skill: "",
          experience: "",
        },
      ],

      languageOptions: ["English", "Urdu"],
      levelOptions: ["Basic", "Conversational", "Native"],
      languageSkillsArr: [
        {
          language: "",
          level: "",
        },
      ],

      workExperience: [
        {
          companyName: "",
          designation: "",
          startingDate: "",
          endDate: "",
          present: false,
          description: "",
        },
      ],

      universities: [],
      degrees: [],
      education: [
        {
          startingDate: "",
          endDate: "",
          present: false,
          details: "",
        },
      ],

      certificates: [
        { certificateName: "", awardedBy: "", startingDate: "", endDate: "" },
      ],

      skills: null,
      skillsOptions: [],
      count_submit: 0,
      current_salary_red: true,
      desired_salary_red: true,
      job_funcation_ch_red: true,
      skill_red: true,
      experience_red: true,
      cnic_red: true,
      name_red: true,
      mobile_red: true,
      address_red: true,
      gender_red: true,
      dob_red: true,
    };
  },

  components: {
    VueEditor,
    InputMask,
  },
  mounted() {
    var link = !!document.querySelector("link[rel='canonical']")
      ? document.querySelector("link[rel='canonical']")
      : document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute(
      "href",
      location.protocol + "//" + location.host + location.pathname
    );
    document.head.appendChild(link);
    this.getInititalData();
  },
  methods: {
    Preview_image() {
      this.url = URL.createObjectURL(this.image);
    },
    onImageLoadFailure(event) {
      event.target.src = "../images/profile_ch.jpg";
    },
    getInititalData() {
      GeneralService.getSingleJobSeekerProfileWithData(this.user_id)
        .then((res) => {
          var jobseker = res.data.jobseker;
          this.gendersOptions = res.data.genders;
          var _res = res.data.profile;
          // fetch job_funcation_ch
          res.data.jobFunction.forEach((element) => {
            this.job_funcation_ch_Options.push({
              value: element.job_function_name,
              text: element.job_function_name,
            });
          });
          this.job_funcation_ch_Options.unshift();

          if (_res.security_questions && _res.security_questions.length > 0) {
            this.security_questions = _res.security_questions;
          }

          // interested options
          res.data.jobShifts.forEach((element) => {
            this.interestedInOptions.push(element.job_shift);
          });

          // cities
          res.data.cities.forEach((element) => {
            this.cityOptions.push(element.city_name);
          });
          // this.cityOptions.unshift(
          //   ...[{ value: "current location", text: "current location" }]
          // );

          // fetch universities
          res.data.universities.forEach((element) => {
            this.universities.push({
              value: element.university_name,
              text: element.university_name,
            });
          });
          this.universities.unshift(...[]);

          // fetch degrees
          res.data.degreeLevel.forEach((element) => {
            this.degrees.push({
              value: element.degree_level,
              text: element.degree_level,
            });
          });
          this.degrees.unshift(...[]);

          // fetch skills
          res.data.skills.forEach((element) => {
            this.skillsOptions.push({
              value: element.skill_name,
              text: element.skill_name,
            });
          });
          this.skillsOptions.unshift(...[{ value: "", text: "Select Skill" }]);

          if (_res) {
            if (_res.profile_pic && _res.profile_pic.length > 0) {
              this.url = this.mediaUrl + _res.profile_pic;
            }

            this.available_for_job = _res.available_for_job;

            if (_res.details && _res.details.length > 0) {
              this.about = _res.details;
            }
            if (_res.area_of_expertise && _res.area_of_expertise.length > 0) {
              this.areaOfExpertise = _res.area_of_expertise;
            }
            if (_res.interested_in && _res.interested_in.length > 0) {
              this.interestedIn = _res.interested_in;
            }
            if (_res.dob && _res.dob.length > 0) {
              this.dob = _res.dob;
            }
            if (_res.cnic && _res.cnic.length > 0) {
              this.cnic = _res.cnic;
            }
            if (_res.gender && _res.gender.length > 0) {
              this.genders = _res.gender;
            }
            if (jobseker.mobile && jobseker.mobile.length > 0) {
              this.mobile = jobseker.mobile;
            }
            if (jobseker.name && jobseker.name.length > 0) {
              this.name = jobseker.name;
            }
            if (jobseker.address && jobseker.address.length > 0) {
              this.address = jobseker.address;
            }
            if (_res.current_salary == "null") {
              this.current_salary = "";
            } else {
              this.current_salary = _res.current_salary;
            }

            if (_res.linkedin && _res.linkedin.length > 0) {
              this.linkedin = _res.linkedin;
            }
            if (_res.website && _res.website.length > 0) {
              this.website = _res.website;
            }
            if (_res.city && _res.city.length > 0) {
              this.city = _res.city;
            }
            if (_res.desired_salary == "null") {
              this.desired_salary = "";
            } else {
              this.desired_salary = _res.desired_salary;
            }

            if (
              _res.willing_to_relocate &&
              _res.willing_to_relocate.length > 0
            ) {
              this.cities = _res.willing_to_relocate;
            }
            if (_res.skills && _res.skills.length > 0) {
              this.skillsArr = _res.skills;
            }
            if (_res.language_skills && _res.language_skills.length > 0) {
              this.languageSkillsArr = _res.language_skills;
            }
            if (_res.education && _res.education.length > 0) {
              this.education = _res.education;
            }
            if (_res.work_experience && _res.work_experience.length > 0) {
              this.workExperience = _res.work_experience;
            }
            if (_res.certificate && _res.certificate.length > 0) {
              this.certificates = _res.certificate;
            }
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    addNewRow() {
      this.workExperience.push({
        companyName: "",
        designation: "",
        startingDate: "",
        endDate: "",
        present: false,
        description: "",
      });
    },
    deleteRow(index) {
      var temp = [];
      this.workExperience.forEach((element, i) => {
        if (i !== index) temp.push(element);
      });
      this.workExperience = temp;
    },

    addNewRow1() {
      this.security_questions.push({
        question: "",
        answer: "",
      });
    },
    deleteRow1(index) {
      var temp = [];
      this.security_questions.forEach((element, i) => {
        if (i !== index) temp.push(element);
      });
      this.security_questions = temp;
    },

    addNewRowSkill() {
      this.skillsArr.push({
        job_funcation_ch: "",
        skill: "",
        experience: "",
      });
    },
    deleteRowSkill(index) {
      var temp = [];
      this.skillsArr.forEach((element, i) => {
        if (i !== index) temp.push(element);
      });
      this.skillsArr = temp;
    },
    addNewRowSkill1() {
      this.languageSkillsArr.push({
        language: "",
        level: "",
      });
    },
    deleteRowSkill1(index) {
      var temp = [];
      this.languageSkillsArr.forEach((element, i) => {
        if (i !== index) temp.push(element);
      });
      this.languageSkillsArr = temp;
    },
    addNewEducationRow() {
      this.education.push({
        // university: null,
        // degree: null,
        startingDate: "",
        endDate: "",
        present: false,
        score: "",
      });
    },
    deleteEducationRow(index) {
      var temp = [];
      this.education.forEach((element, i) => {
        if (i !== index) temp.push(element);
      });
      this.education = temp;
    },
    addNewCertificateRow() {
      this.certificates.push({
        certificateName: "",
        awardedBy: "",
        startingDate: "",
        endDate: "",
      });
    },
    deleteCertificateRow(index) {
      var temp = [];
      this.certificates.forEach((element, i) => {
        if (i !== index) temp.push(element);
      });
      this.certificates = temp;
    },
    form_valdations() {
      if (this.count_submit == 1) {
        if (this.current_salary === "" || this.current_salary === null) {
          this.current_salary_red = false;
        } else {
          this.current_salary_red = true;
        }
        if (this.desired_salary === "" || this.desired_salary === null) {
          this.desired_salary_red = false;
        } else {
          this.desired_salary_red = true;
        }
        if (
          this.skillsArr[0].job_funcation_ch === "" ||
          this.skillsArr[0].job_funcation_ch === null
        ) {
          this.job_funcation_ch_red = false;
        } else {
          this.job_funcation_ch_red = true;
        }
        if (
          this.skillsArr[0].skill === "" ||
          this.skillsArr[0].skill === null ||
          this.skillsArr[0].skill.text == "Select Skill"
        ) {
          this.skill_red = false;
        } else {
          this.skill_red = true;
        }
        if (
          this.skillsArr[0].experience === "" ||
          this.skillsArr[0].experience === null
        ) {
          this.experience_red = false;
        } else {
          this.experience_red = true;
        }
        if (this.cnic === "" || this.cnic === null) {
          this.cnic_red = false;
        } else {
          this.cnic_red = true;
        }
        if (this.name === "" || this.name === null) {
          this.name_red = false;
        } else {
          this.name_red = true;
        }
        if (this.mobile === "" || this.mobile === null) {
          this.mobile_red = false;
        } else {
          this.mobile_red = true;
        }
        if (this.address === "" || this.address === null) {
          this.address_red = false;
        } else {
          this.address_red = true;
        }
        if (this.genders === "" || this.genders === null) {
          this.gender_red = false;
        } else {
          this.gender_red = true;
        }
        if (this.dob === "" || this.dob === null) {
          this.dob_red = false;
        } else {
          this.dob_red = true;
        }
      }
    },
    submit() {
      this.count_submit = 1;
      if (this.current_salary === "" || this.current_salary === null) {
        this.current_salary_red = false;
      } else {
        this.current_salary_red = true;
      }
      if (this.desired_salary === "" || this.desired_salary === null) {
        this.desired_salary_red = false;
      } else {
        this.desired_salary_red = true;
      }
      if (
        this.skillsArr[0].job_funcation_ch === "" ||
        this.skillsArr[0].job_funcation_ch === null
      ) {
        this.job_funcation_ch_red = false;
      } else {
        this.job_funcation_ch_red = true;
      }
      if (
        this.skillsArr[0].skill === "" ||
        this.skillsArr[0].skill === null ||
        this.skillsArr[0].skill.text == "Select Skill"
      ) {
        this.skill_red = false;
      } else {
        this.skill_red = true;
      }
      if (
        this.skillsArr[0].experience === "" ||
        this.skillsArr[0].experience === null
      ) {
        this.experience_red = false;
      } else {
        this.experience_red = true;
      }
      if (this.cnic === "" || this.cnic === null) {
        this.cnic_red = false;
      } else {
        this.cnic_red = true;
      }
      if (this.name === "" || this.name === null) {
        this.name_red = false;
      } else {
        this.name_red = true;
      }
      if (this.mobile === "" || this.mobile === null) {
        this.mobile_red = false;
      } else {
        this.mobile_red = true;
      }
      if (this.address === "" || this.address === null) {
        this.address_red = false;
      } else {
        this.address_red = true;
      }
      if (this.genders === "" || this.genders === null) {
        this.gender_red = false;
      } else {
        this.gender_red = true;
      }
      if (this.dob === "" || this.dob === null) {
        this.dob_red = false;
      } else {
        this.dob_red = true;
      }
      if (this.name === "" || this.name === null) {
        Swal.fire({
          title: "",
          text: "Please add your Name",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      if (this.cnic === "" || this.cnic === null) {
        Swal.fire({
          title: "",
          text: "Please add your CNIC number",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      if (this.mobile === "" || this.mobile === null) {
        Swal.fire({
          title: "",
          text: "Please add your Mobile number",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      if (this.genders === "" || this.genders === null) {
        Swal.fire({
          title: "",
          text: "Please select Current Salary*",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      if (this.dob === "" || this.dob === null) {
        Swal.fire({
          title: "",
          text: "Please add your Date of Birth",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      if (this.address === "" || this.address === null) {
        Swal.fire({
          title: "",
          text: "Please add your Address",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      if (this.current_salary === "" || this.current_salary === null) {
        Swal.fire({
          title: "",
          text: "Please select Current Salary*",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      if (this.desired_salary === "" || this.desired_salary === null) {
        Swal.fire({
          title: "",
          text: "Please select Desired Salary*",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      // console.log(this.skillsArr[0].job_funcation_ch);
      if (
        this.skillsArr[0].job_funcation_ch === "" ||
        this.skillsArr[0].job_funcation_ch === null
      ) {
        Swal.fire({
          title: "",
          text: "Please select your Profession*",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      if (
        this.skillsArr[0].skill === "" ||
        this.skillsArr[0].skill === null ||
        this.skillsArr[0].skill.text == "Select Skill"
      ) {
        Swal.fire({
          title: "",
          text: "Please add your skill*",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      if (
        this.skillsArr[0].experience === "" ||
        this.skillsArr[0].experience === null
      ) {
        Swal.fire({
          title: "",
          text: "Please add your experience*",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      this.submitting = true;
      let formData = new FormData();
      formData.append("profile_pic", this.image);
      formData.append("available_for_job", this.available_for_job ? 1 : 0);
      formData.append("profession", this.job_funcation_ch);
      formData.append("details", this.about);
      formData.append("desired_salary", this.desired_salary);
      formData.append("area_of_expertise", this.areaOfExpertise);
      formData.append("interested_in", this.interestedIn);
      formData.append("dob", this.dob);
      formData.append("cnic", this.cnic);
      formData.append("gender", this.genders);
      formData.append("linkedin", this.linkedin);
      formData.append("current_salary", this.current_salary);
      formData.append("website", this.website);
      formData.append("city", this.city);
      formData.append("willing_to_relocate", this.cities);
      formData.append(
        "security_questions",
        JSON.stringify(this.security_questions)
      );
      formData.append("skills", JSON.stringify(this.skillsArr));
      formData.append(
        "language_skills",
        JSON.stringify(this.languageSkillsArr)
      );
      formData.append("education", JSON.stringify(this.education));
      formData.append("work_experience", JSON.stringify(this.workExperience));
      formData.append("certificate", JSON.stringify(this.certificates));
      formData.append("name", JSON.stringify(this.name));
      formData.append("mobile", JSON.stringify(this.mobile));
      formData.append("address", JSON.stringify(this.address));

      axios.defaults.headers.common["Authorization"] = this.token;

      axios
        .post(`${API_URL}/job-seeker-profile/${this.user_id}`, formData)
        .then((res) => {
          this.loading = false;
          this.success = true;
          this.submitting = false;
          Swal.fire({
            title: "",
            text: "Profile updated",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        })
        .catch(() => {
          this.loading = false;
          this.submitting = false;
          Swal.fire({
            title: "",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
        });
    },
    getProfessions() {
      if (this.count_submit == 1) {
        this.form_valdations();
      }
      let names = this.skillsArr;
      var temp = [];
      this.skillsArr.forEach((element, i) => {
        if (i !== index) temp.push(element);
      });
      this.skillsArr = temp;
      // console.log("temp", temp);
      axios
        .post(`${API_URL}/get-profession/`, { names })
        .then((res) => {})
        .catch(() => {});
    },
    cancel() {
      this.$router.push({ name: "dashboard" });
    },
    resetForm() {
      this.form = [""];
      setTimeout(() => {
        this.$refs.form.reset();
      }, 100);
    },
  },
};
$("#cnic").inputmask();
</script>
